import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import api from 'common/api'

import cn from 'classnames'
import qs from 'querystring'
import { map, isEqual } from 'lodash'
import { Button, List } from '@material-ui/core'

import update from '@scoir/immutability'
import LoadingIndicator from '@scoir/components-core/dist/components/LoadingIndicator'

import Item from './Item'
import FillViewHeight from 'components/FillViewHeight'

import './index.scss'

export class HighSchoolList extends React.Component {
  static propTypes = {
    onSelectHighSchool: PropTypes.func.isRequired,
    dataFilters: PropTypes.object.isRequired,
    shouldAutoSearch: PropTypes.bool.isRequired,
    hasSearchedManually: PropTypes.bool,
  }
  static defaultProps = {
    hasSearchedManually: false,
  }

  state = {
    fetchError: false,
    loading: true,
    displayedSchools: [],
    displayedSchoolsTotal: 0,
  }
  componentDidMount() {
    this.initialLoad(this.props.dataFilters)
  }
  componentDidUpdate(prevProps) {
    const haveFiltersChanged = !isEqual(prevProps.dataFilters, this.props.dataFilters)
    const { shouldAutoSearch, hasSearchedManually } = prevProps
    if (haveFiltersChanged && (shouldAutoSearch || hasSearchedManually)) {
      this.initialLoad(this.props.dataFilters)
    }
  }
  fetch(dataFilters, from, limit = 10) {
    const query = qs.stringify({
      ...dataFilters,
      map: false,
      from,
      limit,
    })
    this.setState({ loading: true })
    return api.get(`/api/highschools/locations?${query}`).catch(() => {
      this.setState({
        loading: false,
        fetchError: true,
      })
      return {
        HighSchoolExplores: [],
        Total: 0,
      }
    })
  }
  initialLoad(filters) {
    this.fetch(filters, 0).then((result) => {
      this.setState({
        loading: false,
        displayedSchools: result.HighSchoolExplores,
        displayedSchoolsTotal: result.Total,
      })
    })
  }
  loadMoreSchools() {
    this.fetch(this.props.dataFilters, this.state.displayedSchools.length).then((result) => {
      this.setState({
        loading: false,
        displayedSchools: update(this.state.displayedSchools, {
          $push: result.HighSchoolExplores,
        }),
      })
    })
  }
  render() {
    const { loading, fetchError, displayedSchools, displayedSchoolsTotal } = this.state
    return (
      <div className={cn('highschool-list-comp', { loading })}>
        {displayedSchools && (
          <FillViewHeight>
            <div className="list-items-section">
              {displayedSchoolsTotal > 0 && (
                <Fragment>
                  <List component="div">
                    {map(displayedSchools, (school) => {
                      return (
                        <Item
                          key={school.HighSchool.Id}
                          onClick={() => this.props.onSelectHighSchool(school.HighSchool)}
                          highSchool={school.HighSchool}
                        ></Item>
                      )
                    })}
                  </List>
                  <div className="view-more-wrap">
                    {loading ? (
                      <div className="loading-indicator">
                        <LoadingIndicator enabled />
                      </div>
                    ) : (
                      displayedSchoolsTotal > displayedSchools.length && (
                        <Button
                          color="primary"
                          size="large"
                          className="view-more-btn"
                          onClick={() => this.loadMoreSchools()}
                        >
                          View More
                        </Button>
                      )
                    )}
                  </div>
                </Fragment>
              )}
              {displayedSchools.length === 0 && (
                <div className="empty-schools-list">
                  <span className="full-height"></span>
                  <span>
                    <h2>{fetchError ? 'Unable to find high schools' : 'No schools currently in view'}</h2>
                  </span>
                </div>
              )}
            </div>
          </FillViewHeight>
        )}
      </div>
    )
  }
}

export default HighSchoolList
